import { PERSONAL_INFORMATION_HISTORY } from 'constant/npay/PersonalInformationTerm';
import AppTermsFrame from '../AppTermsFrame';

const NPayPersonalInformationTerms = () => {
  return (
    <AppTermsFrame
      title="[필수] 개인정보 수집 및 이용 동의"
      url="/npay/personal-information-terms"
      historyData={PERSONAL_INFORMATION_HISTORY}
    />
  );
};

export default NPayPersonalInformationTerms;
